module.exports = __webpack_public_path__ + "media/images/no-result-2-2dddbf785eabf7bad9096ac56eadb93c.jpeg";